import { SiInstagram, SiLinkedin } from "react-icons/si";
import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

export const Header = () => {
    return (
        <header className="fixed top-0 left-0 right-0 z-[2000]">
            <Nav />
        </header>
    );
};

const Nav = () => {
    const [active, setActive] = useState(false);

    return (
        <>
            <HamburgerButton active={active} setActive={setActive} />
            <AnimatePresence>{active && <LinksOverlay />}</AnimatePresence>
        </>
    );
};

const LinksOverlay = () => {
    return (
        <nav className="fixed right-4 top-4 z-40 h-[calc(100vh_-_32px)] w-[calc(100%_-_32px)] overflow-hidden">
            <Logo />
            <LinksContainer />
            <FooterCTAs />
        </nav>
    );
};

const LinksContainer = () => {
    return (
        <motion.div className="space-y-4 p-12 pl-4 md:pl-20">
            {LINKS.map((l, idx) => {
                return (
                    <NavLink key={l.title} href={l.href} idx={idx}>
                        {l.title}
                    </NavLink>
                );
            })}
        </motion.div>
    );
};

const NavLink = ({ children, href, idx }) => {
    return (
        <motion.a
            initial={{ opacity: 0, y: -8 }}
            animate={{
                opacity: 1,
                y: 0,
                transition: {
                    delay: 0.75 + idx * 0.125,
                    duration: 0.5,
                    ease: "easeInOut",
                },
            }}
            exit={{ opacity: 0, y: -8 }}
            href={href}
            className="block text-5xl font-light text-cream transition-colors hover:text-brandy-rose md:text-5xl py-2"
        >
            {children}
        </motion.a>
    );
};

const Logo = () => {
    return (
        <motion.a
            initial={{ opacity: 0, y: -12 }}
            animate={{
                opacity: 1,
                y: 0,
                transition: { delay: 0.5, duration: 0.5, ease: "easeInOut" },
            }}
            exit={{ opacity: 0, y: -12 }}
            href="#"
            className="grid h-20 place-content-center rounded-br-xl rounded-tl-xl bg-cream transition-colors hover:bg-brandy-rose w-fit p-9"
        >
            <a href="/" title="ISILIVING" className="logo">
                <svg
                    version="1.1"
                    x="0px"
                    y="0px"
                    width="257.85px"
                    height="45.42px"
                    viewBox="0 0 257.85 45.42"
                    style={{ overflow: 'visible', enableBackground: 'new 0 0 257.85 45.42' }}
                    xmlSpace="preserve"
                    className="svg replaced-svg"
                >
                    <style type="text/css">
                        {`.st0{fill:#000;}`}
                    </style>
                    <defs></defs>
                    <g>
                        <g>
                            <path className="st0" d="M189.37,17.58c-0.48,0.85-0.28,1.57-0.28,2.24c-0.02,7.72-0.04,15.44,0.02,23.16 c0.01,1.28-0.28,1.8-1.65,1.72c-1.78-0.11-3.58-0.08-5.36-0.01c-1.14,0.05-1.44-0.38-1.44-1.48c0.03-13.65,0.03-27.3,0-40.96 c0-1.1,0.3-1.62,1.45-1.46c0.14,0.02,0.29,0.02,0.43,0c4.28-0.77,6.94,0.83,9.21,4.72c4.27,7.32,9.21,14.26,13.96,21.48 c0.69-0.74,0.43-1.55,0.43-2.25c0.02-7.36,0.06-14.72-0.02-22.09c-0.02-1.5,0.41-2.02,1.91-1.89c1.49,0.13,3.01,0.12,4.5,0 c1.49-0.12,1.95,0.35,1.93,1.88c-0.09,5.86-0.04,11.72-0.04,17.58c0,7.5-0.04,15.01,0.03,22.51c0.01,1.43-0.28,1.97-1.85,1.96 c-5.36-0.01-5.35,0.04-8.25-4.4c-4.77-7.29-9.56-14.57-14.35-21.85C189.82,18.19,189.63,17.94,189.37,17.58z"></path>
                            <path className="st0" d="M257.79,29.12c0,2.64-0.01,5.29,0.01,7.93c0,0.8-0.07,1.48-0.7,2.13c-6.58,6.82-18.32,8.31-26.07,3.16 c-5.34-3.55-8.08-8.78-8.97-14.97c-1.19-8.34,0.43-15.95,6.63-22.1c7.07-7.02,19.69-7.02,26.88-0.12c0.7,0.67,0.86,1.1,0.24,1.91 c-1.35,1.76-2.62,3.57-3.87,5.4c-0.5,0.74-0.92,1.01-1.62,0.24c-0.38-0.42-0.85-0.76-1.31-1.1c-6.4-4.76-13.78-2.96-17.05,4.3 c-2.32,5.14-2.07,10.33,0.7,15.24c3.18,5.62,10.41,7.18,15.87,3.73c1.26-0.8,1.13-1.82,1.13-2.94c0.01-4.2,0.01-4.2-4.23-4.2 c-4.2,0-4.2,0-4.2-4.23c0-4.13,0-4.13,4.12-4.13c3.36,0,6.73,0.14,10.08-0.05c2.08-0.12,2.52,0.64,2.4,2.51 C257.68,24.26,257.79,26.69,257.79,29.12z"></path>
                            <path className="st0" d="M28.62,0.2c6.48-0.03,10.63,1.64,14.34,4.57c0.91,0.72,1.15,1.33,0.36,2.22c-0.09,0.1-0.14,0.25-0.21,0.37 c-1.07,1.77-1.76,4.3-3.33,5.08c-1.56,0.79-3.16-1.75-4.95-2.48c-2.1-0.85-4.18-1.46-6.45-1.07c-1.68,0.29-2.93,1.17-3.26,2.95 c-0.34,1.88,0.22,3.44,2.03,4.28c1.48,0.68,3.04,1.21,4.58,1.77c1.61,0.58,3.27,1.05,4.85,1.69c7.11,2.86,9.67,7.58,8.34,15.3 c-1.06,6.19-5.88,10.2-12.8,10.41c-6.05,0.19-11.34-1.85-15.83-5.95c-0.79-0.72-1.1-1.27-0.29-2.26c1.35-1.65,2.19-4.22,3.88-4.98 c1.88-0.84,3.25,1.97,5.07,2.85c2.78,1.36,5.59,2.16,8.67,1.45c1.84-0.42,3.05-1.5,3.24-3.49c0.18-1.87-0.62-3.18-2.3-3.94 c-1.36-0.61-2.75-1.17-4.16-1.67c-1.61-0.58-3.26-1.04-4.88-1.61c-7.67-2.69-9.74-7.71-8.49-15.54 C18.05,3.88,23.24,0.17,28.62,0.2z"></path>
                            <path className="st0" d="M118.94,0.8c2.84,0,5.55,0.04,8.25-0.02c1.31-0.03,1.21,1,1.44,1.72c2.74,8.48,5.45,16.97,8.17,25.45 c0.32,1,0.66,2,1.14,3.43c1.13-3.48,2.14-6.59,3.13-9.7c2.07-6.45,4.16-12.9,6.18-19.37c0.35-1.12,0.79-1.65,2.06-1.56 c1.85,0.12,3.72,0.12,5.58,0.01c1.64-0.1,1.9,0.33,1.34,1.9c-4.05,11.5-8.02,23.04-12.01,34.56c-0.72,2.09-1.55,4.15-2.14,6.28 c-0.34,1.23-0.97,1.48-2.14,1.48c-5.82,0.04-5.81,0.07-7.7-5.41c-4.28-12.4-8.58-24.8-12.86-37.21 C119.21,1.92,119.11,1.44,118.94,0.8z"></path>
                            <path className="st0" d="M70.58,22.77c0-6.57,0.09-13.15-0.06-19.72c-0.05-1.99,0.58-2.48,2.4-2.28c1.34,0.15,2.72,0.12,4.07,0 c1.48-0.13,1.93,0.34,1.92,1.87c-0.07,9.07-0.04,18.15-0.03,27.22c0,1.5,0.08,3.01-0.02,4.5c-0.08,1.23,0.36,1.56,1.56,1.55 c5.15-0.06,10.3,0.06,15.45-0.07c1.69-0.04,2.06,0.49,1.94,2.03c-0.13,1.78-0.09,3.57-0.01,5.36c0.05,1.11-0.3,1.46-1.44,1.46 c-8.08-0.04-16.16-0.07-24.24,0.01c-1.49,0.01-1.56-0.63-1.55-1.78C70.59,36.2,70.58,29.48,70.58,22.77z"></path>
                            <path className="st0" d="M61.2,22.77c0,6.72-0.04,13.44,0.04,20.16c0.02,1.42-0.38,1.87-1.78,1.77c-1.64-0.11-3.3-0.13-4.93,0 c-1.58,0.13-1.86-0.52-1.85-1.95c0.05-13.37,0.06-26.73-0.01-40.1c-0.01-1.53,0.43-2.01,1.92-1.88c1.49,0.12,3.01,0.13,4.5,0 c1.62-0.14,2.19,0.29,2.16,2.06C61.13,9.47,61.2,16.12,61.2,22.77z"></path>
                            <path className="st0" d="M104.23,22.8c0-6.72,0.05-13.44-0.04-20.16c-0.02-1.54,0.45-1.98,1.93-1.88c1.71,0.12,3.43,0.09,5.15,0.01 c1.09-0.05,1.49,0.25,1.48,1.41c-0.04,13.72-0.03,27.45,0,41.17c0,1.04-0.32,1.37-1.34,1.33c-1.86-0.07-3.73-0.11-5.58,0.01 c-1.4,0.09-1.64-0.49-1.63-1.74C104.26,36.24,104.23,29.52,104.23,22.8z"></path>
                            <path className="st0" d="M8.45,22.81c0,6.57-0.08,13.15,0.05,19.72c0.04,1.88-0.56,2.32-2.28,2.16c-1.56-0.15-3.15-0.08-4.72-0.01 c-1.09,0.05-1.5-0.27-1.5-1.43C0.04,29.59,0.04,15.95,0,2.3c0-1.29,0.48-1.57,1.64-1.52c1.71,0.08,3.44,0.11,5.15-0.01 c1.33-0.09,1.7,0.35,1.69,1.67C8.41,9.23,8.44,16.02,8.45,22.81z"></path>
                            <path className="st0" d="M162.98,22.82c0-6.71,0.04-13.42-0.03-20.13c-0.02-1.45,0.29-2.08,1.85-1.91c2.11,0.23,4.87-0.87,6.18,0.45 c1.21,1.22,0.33,3.95,0.33,6.01c0.03,11.78-0.02,23.56,0.05,35.34c0.01,1.69-0.44,2.3-2.13,2.1c-2.03-0.23-4.76,0.87-5.92-0.44 c-1.01-1.14-0.33-3.8-0.34-5.79C162.96,33.24,162.98,28.03,162.98,22.82z"></path>
                        </g>
                    </g>
                </svg>
            </a>
        </motion.a>
    );
};

const HamburgerButton = ({ active, setActive }) => {
    return (
        <>
            <motion.div
                initial={false}
                animate={active ? "open" : "closed"}
                variants={UNDERLAY_VARIANTS}
                style={{ top: 16, right: 16 }}
                className="fixed z-10 rounded-xl bg-gradient-to-br from-[#303030] to-[#303030] shadow-lg shadow-neutral-800/20"
            />

            <motion.button
                initial={false}
                animate={active ? "open" : "closed"}
                onClick={() => setActive((pv) => !pv)}
                className={`group fixed right-4 top-4 z-50 h-20 w-20 bg-white/0 transition-all hover:bg-white/20 ${active ? "rounded-bl-xl rounded-tr-xl" : "rounded-xl"
                    }`}
            >
                <motion.span
                    variants={HAMBURGER_VARIANTS.top}
                    className="absolute block h-1 w-10 bg-white"
                    style={{ y: "-50%", left: "50%", x: "-50%" }}
                />
                <motion.span
                    variants={HAMBURGER_VARIANTS.middle}
                    className="absolute block h-1 w-10 bg-white"
                    style={{ left: "50%", x: "-50%", top: "50%", y: "-50%" }}
                />
                <motion.span
                    variants={HAMBURGER_VARIANTS.bottom}
                    className="absolute block h-1 w-5 bg-white"
                    style={{ x: "-50%", y: "50%" }}
                />
            </motion.button>
        </>
    );
};

const FooterCTAs = () => {
    return (
        <>
            <div className="absolute bottom-6 left-6 flex gap-4 md:flex-row">
                {SOCIAL_CTAS.map((l, idx) => {
                    return (
                        <motion.a
                            key={idx}
                            href={l.href}
                            initial={{ opacity: 0, y: -8 }}
                            animate={{
                                opacity: 1,
                                y: 0,
                                transition: {
                                    delay: 1 + idx * 0.125,
                                    duration: 0.5,
                                    ease: "easeInOut",
                                },
                            }}
                            exit={{ opacity: 0, y: -8 }}
                        >
                            <l.Component className="text-6xl text-cream transition-colors hover:text-brandy-rose" />
                        </motion.a>
                    );
                })}
            </div>

            <motion.button
                initial={{ opacity: 0, y: 8 }}
                animate={{
                    opacity: 1,
                    y: 0,
                    transition: {
                        delay: 1.125,
                        duration: 0.5,
                        ease: "easeInOut",
                    },
                }}
                exit={{ opacity: 0, y: 8 }}
                className="absolute bottom-2 right-2 flex items-center gap-2 rounded-full bg-cream px-3 py-3 text-4xl uppercase text-cocoa-600 transition-colors hover:bg-brandy-rose hover:text-cocoa-500 md:bottom-4 md:right-4 md:px-6 md:text-2xl"
            >
                <a href="/contact" className="hidden md:block">contact us</a> <FiArrowRight />
            </motion.button>
        </>
    );
};

const LINKS = [
    {
        title: "Accueil",
        href: "/",
    },
    {
        title: "Catégorie",
        href: "/categories",
    },
    {
        title: "Bureau d'étude et réalisations",
        href: "/projects",
    },
    {
        title: "Nos marques",
        href: "/our-brands",
    },
    {
        title: "Notre Histoire",
        href: "/our-history",
    },
    {
        title: "e-Shop",
        href: "https://x0m31k-rp.myshopify.com/",
    },
];

const SOCIAL_CTAS = [
    {
        Component: SiInstagram,
        href: "https://www.instagram.com/isilivingofficial/",
    },
    {
        Component: SiLinkedin,
        href: "https://fr.linkedin.com/company/isiliving",
    },
];

const UNDERLAY_VARIANTS = {
    open: {
        width: "calc(100% - 32px)",
        height: "calc(100vh - 32px)",
        transition: { type: "spring", mass: 3, stiffness: 400, damping: 50 },
    },
    closed: {
        width: "80px",
        height: "80px",
        transition: {
            delay: 0.75,
            type: "spring",
            mass: 3,
            stiffness: 400,
            damping: 50,
        },
    },
};

const HAMBURGER_VARIANTS = {
    top: {
        open: {
            rotate: ["0deg", "0deg", "45deg"],
            top: ["35%", "50%", "50%"],
        },
        closed: {
            rotate: ["45deg", "0deg", "0deg"],
            top: ["50%", "50%", "35%"],
        },
    },
    middle: {
        open: {
            rotate: ["0deg", "0deg", "-45deg"],
        },
        closed: {
            rotate: ["-45deg", "0deg", "0deg"],
        },
    },
    bottom: {
        open: {
            rotate: ["0deg", "0deg", "45deg"],
            bottom: ["35%", "50%", "50%"],
            left: "50%",
        },
        closed: {
            rotate: ["45deg", "0deg", "0deg"],
            bottom: ["50%", "50%", "35%"],
            left: "calc(50% + 10px)",
        },
    },
};